export enum EMainRoutes {
	DASHBOARD = '/',
	CATALOG = 'catalog',
	CHANNELS = 'channels',
	CHANNEL = 'channel',
	PLANNER = 'planner',
	HISTORY = 'history',
	BRAND = 'brand',
	POST = 'post',
	CREATE = 'create',
	EDIT = 'edit',
	FINANCES = 'finances',
	REPORTS = 'reports',
	ACCOUNT = 'account',
	LOG_IN = 'login',
	LOG_OUT = 'logout',
	PROFILE = 'profile',
	SETTINGS = 'settings',
	TASKS = 'tasks',
	MORE = 'more',
}
